import React from 'react';

import * as S from './styles';

const Slide9: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Subtitle>
        Camisa, Reinaldo Lourenço, R$ 1.299. Casaco, Vitor Zerbinato, preço sob
        consulta. Calça, Nosf, R$ 480. Sandálias, acervo ELLE. À frente, calça e
        botas, Dolce & Gabbana, preços sob consulta. Luvas, Moun, R$ 229.
      </S.Subtitle>
    </S.Container>
  );
};

export { Slide9 };
